module.exports = __webpack_public_path__ + "static/media/power-def.5ba0f1f1.png";